module.exports = __webpack_public_path__ + "static/media/lizinde_kagarama6.7bd27118.jpeg";